import Splide from '@splidejs/splide';

const slider = () => {
    if( document.querySelector('.splide') ) {
        new Splide( '.splide', {
            type   : 'loop',
            speed: 4000,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
            pagination: false,
            autoplay: true,
        } ).mount();
    }
}

export default slider;